<div class="cpu-model-container" *ngIf="!isLoadingLabels && !isLoadingCpuModels">
	<div *ngIf="cpuModelInterface.id == undefined">
		<cpi-msp-table
			[header]="searchHeader"
			[body]="cpuModelsList"
			[searchable]="true"
			[height]="'55dvh'"
			[itemPadding]="'1%'"
			[labels]="labels"
			[insideSort]="true"
			(getSelectedItem)="openForm($event[0])">
		</cpi-msp-table>

		<div class="button-container">
			<div class="button" (click)="clearInputs(true)">{{ labels.lbl_geral_novo }}</div>
		</div>
	</div>

	<ng-container *ngIf="cpuModelInterface.id != undefined">
		<div class="header-wrap">
			<span class="tab selected">{{ labels.lbl_asset_processadores }}</span>
		</div>
		<div class="body-wrap">
			<div class="search-container">
				<div class="form-container">
					<div class="dotted-input-container">
						<span>Tipo de CI*</span>
						<select id="ci_type" name="ci_type" [(ngModel)]="cpuModelInterface.ci_type">
							<option [value]="''" selected>{{ labels.lbl_geral_selecione }}</option>
							<option *ngFor="let option of ciTypeList" [value]="option.id">{{ option.label }}</option>
						</select>
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_asset_cpu }}*</span>
						<input id="cpu" name="cpu" type="text" [(ngModel)]="cpuModelInterface.cpu" />
					</div>
				</div>

				<div class="button-container">
					<div class="button" (click)="clearInputs(false)">{{ labels.lbl_geral_voltar }}</div>
					<div class="button" (click)="clearInputs(true)">{{ labels.lbl_geral_novo }}</div>
					<div class="button" *ngIf="cpuModelInterface.id !== ''" (click)="deleteCpuModel($event)" #deleteButton>
						{{ deleteButton.classList.contains('double-click') ? labels.lbl_geral_confirmar : labels.lbl_geral_excluir }}
					</div>
					<div class="button" type="submit" (click)="validateForm()">{{ labels.lbl_geral_salvar }}</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect
	class="mt-2 ml-2"
	*ngIf="isLoadingCpuModels || isLoadingLabels"
	[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
